export default __webpack_public_path__ + "static/media/work_error.8738fe12.png";